/// <reference path="../definitions.d.ts"/>
import {BuildPropertyType} from '@gongxigames/framework/slot/types/EnvironmentProperty';
import {SplashScreen} from '@gongxigames/framework/slot/fragments/SplashScreen';

export function initGlobals(): void {
    // eslint-disable-next-line prefer-const
    let buildProperty = {} as BuildPropertyType;

    document.addEventListener('gesturestart', e => {
        e.preventDefault();
    });

    // webpack inserts code here
    buildProperty = {"env":"dev","operator":"rubyplay","versions":{"framework":"7.3.2","gameVersion":"1.0.112","clientVersion":"1.0.0","binaryResourcesVersion":"wolfhavenFui_v2_0.26-Gv4-V3.0.1-H0ac147c84fb0fe43e418d9163f691256132f308ff541bd4053e62e34ef8ac4db","game":"F7.3.2-G1.0.112-Mwolfhaven-1.0.19-Hf34d3a56-dev","gameName":"wolfhaven","math":"wolfhaven - 1.0.19","integration":"rubyplay","buildType":"dev","buildDate":1770047264803,"buildNumber":"561"},"gameProperty":{"resourcePaths":{"binary":"wolfhaven/wolfhavenFui_v2_0.26-Gv4-V3.0.1-H0ac147c84fb0fe43e418d9163f691256132f308ff541bd4053e62e34ef8ac4db/binary/","staticFolder":"static/"},"skinName":"wolfhaven"}};

    window.RP_CONFIG.buildProperty = buildProperty;

    if (!window.RP_CONFIG.sessionsURL) {
        window.RP_CONFIG.sessionsURL = 'https://sessions.rubyplay.tech/api/sessions';
    }

    window.versions = {
        ...buildProperty.versions
    };
    

    window.splashScreen = new SplashScreen();
}
